export default {
      id: "i-tick-usage",
      viewBox: "0 0 14 12",
      url: __webpack_public_path__ + "img/sprite.svg#i-tick",
      toString: function () {
        return this.url;
      }
    }